export const isValidResponse = (res) => {
	if (res?.success) {
		return true
	}
	return false
}

export const isValidResponseExternal = (res) => {
  if (!res) {
		return false
	}
	return res
}
